import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import styles from "./buyerPRList.module.scss";

interface BuyerPRListProps {
  title?: string;
  data?: any[];
  buyerKey?: string;
  completedKey?: string;
  totalKey?: string;
}

const BuyerPRList: React.FC<BuyerPRListProps> = ({
  title = "PR by Buyers",
  data = [],
  buyerKey = "buyer",
  completedKey = "completed",
  totalKey = "total",
}) => {
  const defaultColor = "#00d2aa";

  const chartData = useMemo(() => {
    if (!data || data.length === 0) return [];

    return data.map((item, index) => ({
      buyer: item[buyerKey] || `Buyer ${index + 1}`,
      completed: Number(item[completedKey] || 0),
      total: Number(item[totalKey] || 0),
    }));
  }, [data, buyerKey, completedKey, totalKey]);

  const maxValue = useMemo(() => {
    if (chartData.length === 0) return 100;
    return Math.max(...chartData.map((item) => item.total), 1);
  }, [chartData]);

  if (!chartData || chartData.length === 0) {
    return (
      <Box className={styles.container}>
        <Box className={styles.header}>
          <Typography variant="h6" className={styles.title}>
            {title}
          </Typography>
        </Box>
        <Box
          className={styles.listContainer}
          display="flex"
          alignItems="center"
          justifyContent="center"
          minHeight={200}
        >
          <Typography variant="body2" color="textSecondary">
            No data available
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="h6" className={styles.title}>
          {title}
        </Typography>
      </Box>

      <Box className={styles.listContainer}>
        {chartData.map((item, index) => (
          <Box key={index} className={styles.listItem}>
            <Typography className={styles.buyerName}>{item.buyer}</Typography>
            <Box className={styles.barSection}>
              <Box className={styles.barBackground}>
                <Box
                  className={styles.barFill}
                  style={{
                    width: `${(item.total / maxValue) * 100}%`,
                    background: defaultColor,
                  }}
                />
              </Box>
            </Box>
            <Typography className={styles.ratio}>
              {item.completed}/{item.total}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BuyerPRList;
